export default __webpack_public_path__ + "static/media/expanded.e1a96a71.svg";